import { CONTRACT_TRADING } from '@/constans/trade';
import { DexTrading__factory } from '@/contracts';
import { CONSTANT } from '@/store/constants';
import { usePairs } from '@/store/pairs';
import { usePrice } from '@/store/price';
import { getErrorMessage } from '@/utils/get-error';
import { waitForTransactionReceipt } from '@/utils/wait-transaction';
import { MiniKit } from '@worldcoin/minikit-js';
import BigNumber from 'bignumber.js';
import { t } from 'i18next';
import { mutate } from 'swr';
import { ViewTransaction } from '../ViewTransaction/ViewTransaction';
import { toastApp } from '../toast-message/sonner';
import { FormValue, OrderType } from './type';
import { calculateTpSLSubmit } from './calculateTpSLSubmit';

function getOpenPrice(
    pairIndex: string,
    orderType: OrderType,
    limitPrice: string
) {
    if (orderType === OrderType.Limit) {
        return limitPrice;
    }

    return usePrice.getState().data?.[pairIndex]?.price;
}

export function OpenTrade(props: {
    address: string;
    buy: boolean;
    onSuccess: () => void;
}) {
    const { address, buy, onSuccess } = props;
    return async ({
        pairIndex,
        orderType,
        limitPrice,
        leverage,
        amount,
        sl,
        tp,
    }: FormValue) => {
        const infoPair = usePairs
            .getState()
            .data.find((item) => item.pairIndex === Number(pairIndex));
        const id = 'tx-toast';

        try {
            const openPrice = getOpenPrice(pairIndex, orderType, limitPrice);
            const { stopLoss, takeProfit } = calculateTpSLSubmit({
                entryPrice: Number(openPrice),
                typeTrade: buy ? 'Long' : 'Short',
                leverage: Number(leverage),
                tpPercent: Number(tp || 0),
                slPercent: Number(sl || 0),
                amount: Number(amount),
                decimalsToShow: infoPair?.decimalsToShow ?? 6,
            });

            const tradeStuct = [
                address,
                pairIndex,
                '0',
                '0',
                new BigNumber(amount).multipliedBy(1e18).toFixed(0),
                new BigNumber(openPrice).multipliedBy(1e10).toString(),
                buy,
                String(leverage),
                new BigNumber(takeProfit).multipliedBy(1e10).toString(),
                new BigNumber(stopLoss).multipliedBy(1e10).toString(),
            ];

            console.log('tradeStuct', Object.assign({}, tradeStuct));
            const deadline = Math.floor(
                (Date.now() + 3 * 60 * 1000) / 1000
            ).toString();
            const amountSubmit = new BigNumber(amount)
                .multipliedBy(1e18)
                .toFixed(0);

            // Transfers can also be at most 1 hour in the future.
            const permitTransfer = {
                permitted: {
                    token: CONSTANT.WLD,
                    amount: amountSubmit,
                },
                nonce: Date.now().toString(),
                deadline,
            };

            const permitTransferArgsForm = [
                [
                    permitTransfer.permitted.token,
                    permitTransfer.permitted.amount,
                ],
                permitTransfer.nonce,
                permitTransfer.deadline,
            ];

            const transferDetails = {
                to: CONTRACT_TRADING.TRADING_STORE,
                requestedAmount: amountSubmit,
            };

            const transferDetailsArgsForm = [
                transferDetails.to,
                transferDetails.requestedAmount,
            ];

            const spreadReductionId = '0';
            const slippageP = new BigNumber(10400000000).toString();

            console.debug('------args', [
                permitTransferArgsForm,
                transferDetailsArgsForm,
                tradeStuct,
                orderType,
                spreadReductionId,
                slippageP,
                'PERMIT2_SIGNATURE_PLACEHOLDER_0',
            ]);

            const payload = {
                transaction: [
                    {
                        address: CONTRACT_TRADING.TRADING,
                        abi: DexTrading__factory.abi,
                        functionName: 'openTrade',
                        args: [
                            permitTransferArgsForm,
                            transferDetailsArgsForm,
                            tradeStuct,
                            orderType,
                            spreadReductionId,
                            slippageP,
                            'PERMIT2_SIGNATURE_PLACEHOLDER_0',
                        ],
                    },
                ],
                permit2: [
                    {
                        ...permitTransfer,
                        spender: CONTRACT_TRADING.TRADING,
                    },
                ],
            };

            const { finalPayload } =
                await MiniKit.commandsAsync.sendTransaction(payload);
            console.log('finalPayload', finalPayload);

            if (finalPayload.status === 'error') {
                throw new Error(finalPayload.error_code);
            }

            toastApp.loading(t('Transaction Submitted'), id);
            onSuccess();
            sessionStorage.setItem('OPEN_TRADE', finalPayload.transaction_id);

            const txHash = await waitForTransactionReceipt(
                finalPayload.transaction_id
            );

            console.log('finalPayload1', finalPayload);

            const message = (
                <ViewTransaction
                    txUrl={`${CONSTANT.URL_SCAN}${txHash}`}
                    title={t('Position Opened')}
                />
            );
            console.log('finalPayload2', finalPayload);

            toastApp.success(message, id);
            window.postMessage({ type: 'OPEN_TRADE', txHash: txHash, transaction_id:finalPayload.transaction_id });

            await mutate({ key: 'fetch-balance', address });
        } catch (e) {
            const errorMessage = getErrorMessage(e);

            console.error('error', e);

            toastApp.error(errorMessage, id);
        }
    };
}
